import type { QuestionnaireItem, QuestionnaireResponseItem } from "fhir/r3"
import { enableWhenConditionsMet } from "./enableWhenConditionsMet"

export function questionClass(question: QuestionnaireItem, responses: QuestionnaireResponseItem[]): string {
  if (question.enableWhen == null) {
    return ""
  }

  const conditionsMet = enableWhenConditionsMet(question.enableWhen ?? [], responses)

  if (conditionsMet) {
    return "hidden-question show"
  }

  return "hidden-question"
}
